
import React from "react";

// import Sidebar from "../components/navbar/Sidebar";

// import
// import GeneralInformation from "../forms/GeneralInformation"
import MainContactForm from "../forms/organization/MainContact";
// import OrganizationResearchersForm from "../forms/organization/OrganizationResearchers";
// import AddDeleteOrganizationRows from "../forms/organization/AddDeleteOrganizationRows";

// import Layout from "../components/Layout";
// import Layout from "components/layout/_Layout"

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";


function Organization() {
 return (



   <div className="container">
     <Row>
      
      {/* <Col md={2}>
       <Sidebar />
       </Col> */}

       <Col md={10}>
         {/* <LegalStatusForm />  */}
        
         <MainContactForm/>
         
        {/* <OrganizationDataForm /> */}

         {/* <SMEForm /> */}
      </Col>
      
   </Row>
      
   </div>

  
   );
}
export default Organization;
